import _ from 'lodash';

angular
  .module(__filename, [])

  .directive(
    'alphabetPicker',
    ngInject(() => ({
      restrict: 'E',

      scope: {
        label: '@?', // only used on mobile view
        values: '=',
      },

      template: require('./template'),

      link(scope) {
        scope.filters = ['all'].concat('#abcdefghijklmnopqrstuvwxyz'.split(''));
        scope.selectedFilter = 'all';

        const updateSelectableFilters = () =>
          (scope.selectableFilters = ['all'].concat(
            _(scope.values)
              .chain()
              .filter((value) => value != null)
              .map(function(value) {
                let letter = value[0].toLowerCase();
                if (letter.match(/\d/)) {
                  letter = '#';
                }
                return letter;
              })
              .uniq()
              .sortBy()
              .value(),
          ));
        updateSelectableFilters();

        scope.selectFilter = (filter) => (scope.selectedFilter = filter);

        scope.isSelectable = (filter) => Array.from(scope.selectableFilters).includes(filter);

        scope.$watch('values', updateSelectableFilters);
      },
    })),
  );

export default __filename;
